import { getEntityWithImageUrl } from './imagePath';

// Decorator for Bonuses and Campaigns content

export const getBonusContentEntity = (entity, contentAPIPrefix) => ({
  id: entity.external_id,
  title: entity.title,
  description: entity.description,
  terms: entity.terms,
  image: entity.image,
  categories: entity.categories.map((item) =>
    getEntityWithImageUrl(item, contentAPIPrefix, 'icon')
  ),
  buttons: entity.buttons,
  wager: entity.wager,
});
